import React from "react"

interface DateInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    label: string,
    error?: boolean
    message?: string,
    className?: string
}

const DateInput: React.FC<DateInputProps> = ({
    label,
    value,
    message,
    required,
    error,
    className,
    ...inputProps
}) => {
    return (
        <div className={`input-container ${error ? 'error' : ''} ${className}`}>
            <span className="input-label">{label}{required && '*'}</span>
            <input type={"date"} className="input" value={value} required={required} {...inputProps} />
            {message && <span className={`input-message`}>{message}</span>}
        </div>
    )
}

export default DateInput